import { Box, Typography } from '@mui/material';
import { MoneyNoteIcon } from './bankNoteComponent';
import { TamaraLogo } from './tamaraLogo';
import { TabbyLogo } from './tabbyLogo';
import { useTranslations } from 'next-intl';

const TAMARA_GRADIENT = 'linear-gradient(135deg, #FF6B9D 0%, #C6FFDD 25%, #FBD786 50%, #F7797D 75%, #A8EDEA 100%)';
const TABBY_COLOR = '#5AFEAE';

const logoCircleBaseStyles = {
    width: 22,
    height: 22,
    borderRadius: '50%',
    border: '1.5px solid white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
};

export default function EMIPaymentCard({ emiAmount = "", installments = 4 }) {
    const t = useTranslations('common');

    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 1.5,
            bgcolor: '#fefce8',
            borderRadius: 1,
            p: 1.25,
            mt: 2
        }}>
            <Box sx={{ mt: 0.5 }}>
                <MoneyNoteIcon />
            </Box>

            <Box sx={{ flex: 1 }}>
                <Box sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                    color: '#111827',
                    mb: 0.25
                }}>
                    {t('payWithInstallments', { installments })}{"   "}
                    <Box
                        component="span"
                        sx={{
                            fontSize: '16px',
                            fontWeight: 700,
                            whiteSpace: 'nowrap',
                            mx: 0.5,
                        }}
                    >
                        {t('atPerMonth', { emiAmount })}
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Typography sx={{ fontSize: '12px', color: '#6b7280' }}>
                        {t('withTamaraAndTabby')}
                    </Typography>

                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {/* Tamara Logo Circle */}
                        <Box sx={{
                            ...logoCircleBaseStyles,
                            background: TAMARA_GRADIENT,
                            zIndex: 2,
                        }}>
                            <TamaraLogo sx={{ fontSize: 18 }} />
                        </Box>

                        {/* Tabby Logo Circle */}
                        <Box sx={{
                            ...logoCircleBaseStyles,
                            bgcolor: TABBY_COLOR,
                            ml: -0.75,
                            zIndex: 1,
                        }}>
                            <TabbyLogo sx={{ fontSize: 18 }} />
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}